export const SEARCH_PREVIEW = 'search-preview';
export const SEARCH_PREVIEW_SEE_ALL_RESULTS = 'search-preview-see-all-results';
export const MAX_SEARCH_HEIGHT = 630;
